import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import {
  add_all_access_category,
  update_all_access_category,
} from "../../data/ApiEndpoints";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import MultiSelect from "../components-react/MultiSelect";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.catName) {
    errors.catName = "Required!";
  }

  if (formValues.selectedGyms?.length === 0) {
    errors.selectedGyms = "Required!";
  }

  const featureErrorsArray = formValues.featuresArray.map((feature) => {
    const featureErrors = {};
    if (!feature.feature_name) {
      featureErrors.feature_name = "Feature name is required!";
    } else if (feature.feature_name.length > 50) {
      featureErrors.feature_name = "Feature name cannot exceed 50 characters!";
    }
    return Object.keys(featureErrors).length > 0 ? featureErrors : null;
  });

  if (featureErrorsArray.some((error) => error !== null)) {
    errors.featuresArray = featureErrorsArray;
  }

  return errors;
};

const AllAccessCatForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading } = useSelector((state) => state.postApi);

  const forminitials = {
    catName: isEdit && rowData?.name ? rowData.name : "",
    selectedGyms:
      rowData?.category_gyms?.length > 0 && gymData?.length > 0
        ? gymData
            .filter((gym) =>
              rowData.category_gyms.some(
                (rowGym) => rowGym.gym_id === gym.value
              )
            )
            .map((gym) => ({
              value: gym.value,
              label: gym.label,
            }))
        : [],
    featuresArray:
      isEdit && rowData?.category_features
        ? rowData.category_features.map((feature) => ({
            feature_name: feature.feature_name,
          }))
        : [{ feature_name: "" }],
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeInputFeatures = (e, index) => {
    const { name, value } = e.target;
    setFormValues((prevs) => {
      const updatedFeatures = [...prevs.featuresArray];
      updatedFeatures[index][name] = value;
      return { ...prevs, featuresArray: updatedFeatures };
    });
  };

  const handleFeatureAdd = (e) => {
    e.preventDefault();
    setFormValues((prevs) => ({
      ...prevs,
      featuresArray: [...prevs.featuresArray, { feature_name: "" }],
    }));
  };

  const deleteFeature = (e, index) => {
    e.preventDefault();
    setFormValues((prevs) => ({
      ...prevs,
      featuresArray: prevs.featuresArray.filter((_, idx) => idx !== index),
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? update_all_access_category
      : add_all_access_category;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    if (isEdit && rowData) {
      const matchedGyms =
        rowData?.category_gyms?.length > 0 && gymData?.length > 0
          ? gymData
              .filter((gym) =>
                rowData.category_gyms.some(
                  (rowGym) => rowGym.gym_id === gym.value
                )
              )
              .map((gym) => ({
                value: gym.value,
                label: gym.label,
              }))
          : [];
      const matchedFeatures =
        rowData?.category_gyms?.length > 0
          ? rowData.category_features?.map((feature) => ({
              feature_name: feature.feature_name,
            })) || [{ feature_name: "" }]
          : [];

      setFormValues((prev) => ({
        ...prev,
        catName: rowData.name || "",
        selectedGyms: matchedGyms,
        featuresArray: matchedFeatures,
        isActive: rowData.status === "active",
      }));
    }
  }, [gymData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const allGyms = formValues.selectedGyms.map((gym) => gym?.value);
      const allFeatures = formValues.featuresArray.map(
        (feature) => feature?.feature_name
      );

      const userData = {
        name: formValues.catName || "",
        category_gyms: allGyms || [],
        category_features: allFeatures || [],
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Category`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="catName" className={`formInputLabel `}>
              category name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Category Name"
              className={`formInput ${formErrors?.catName ? "formError" : ""}`}
              name="catName"
              value={formValues.catName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedGyms" className="formInputLabel">
              select gym <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper no-border multi-select ${
                formErrors.selectedGyms ? "error" : ""
              }`}
            >
              <MultiSelect
                options={gymData?.length > 0 ? gymData : []}
                state={formValues.selectedGyms}
                setState={(selectedValue) =>
                  setFormValues((prevs) => ({
                    ...prevs,
                    selectedGyms: selectedValue,
                  }))
                }
                name="select multiple from the list"
              />
            </div>
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`${formValues.isActive ? "Active" : "Not Active"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>
        </div>

        {formValues.featuresArray?.map((featureData, index) => (
          <div key={index} className="formInputsGrid twoGridSystem">
            <div className="formInputBox span2">
              <label htmlFor="feature_name" className={`formInputLabel`}>
                Feature {index + 1} (Max 50 Characters -{" "}
                {featureData.feature_name?.length}) *
              </label>

              <div className="multi-row-features">
                <textarea
                  name="feature_name"
                  className={`formInput ${
                    formErrors.featuresArray?.[index]?.feature_name
                      ? "formError"
                      : ""
                  }`}
                  style={{
                    background: "#fff",
                  }}
                  placeholder="Enter Feature"
                  value={formValues.featuresArray[index].feature_name || ""}
                  onChange={(e) => onChangeInputFeatures(e, index)}
                ></textarea>

                <div className="action-btns-container">
                  {formValues.featuresArray?.length !== 1 ? (
                    <button
                      className="action-btn delete-btn"
                      type="button"
                      onClick={(e) => deleteFeature(e, index)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash3-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                      </svg>
                    </button>
                  ) : null}

                  {formValues.featuresArray?.length === 0 ||
                  (index === formValues.featuresArray?.length - 1 &&
                    formValues.featuresArray?.length < 10) ? (
                    <button
                      className="action-btn add-btn"
                      type="button"
                      onClick={handleFeatureAdd}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-circle"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                      </svg>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        ))}
      </form>
    </div>
  );
};

export default AllAccessCatForm;
